import MenuPage from './pages/MenuPage.vue'
import PrincipalPage from './pages/PrincipalPage.vue'
import OrientacoesPage from './pages/OrientacoesPage.vue'
import MenuXPerfilPage from './pages/MenuXPerfilPage.vue'

const routes = [
  {
    path: 'menus',
    name: 'menus',
    component: MenuPage
  },
  {
    path: 'menus/principal',
    name: 'menus-principal',
    component: PrincipalPage
  },
  {
    path: 'menus/orientacoes',
    name: 'menus-orientacoes',
    component: OrientacoesPage
  },
  {
    path: 'menus/menu-x-perfil',
    name: 'menu-x-perfil',
    component: MenuXPerfilPage
  }
];

export default routes;